import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Button } from "components/bootstrap";
import SuggestionRow from "./SuggestionRow";
import useEventDefinitionSuggestions from "../hooks/useEventDefinitionSuggestions";
const Wrapper = styled.div`
  border-left: 3px solid ${({ theme }) => theme.colors.variant.light.info};
  padding: ${({ theme }) => `${theme.spacings.xs} ${theme.spacings.sm}`};
  margin-bottom: ${({ theme }) => theme.spacings.sm};
  background: ${({ theme }) => theme.colors.variant.lightest.info};
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacings.xs};
`;
const Summary = styled.p`
  font-style: italic;
  opacity: 0.85;
  margin: ${({ theme }) => `0 0 ${theme.spacings.xs}`};
  padding-left: ${({ theme }) => theme.spacings.xs};
  border-left: 2px solid ${({ theme }) => theme.colors.cards.border};
`;
const Group = styled.details`
  margin: ${({ theme }) => `${theme.spacings.xxs} 0`};

  & > summary {
    cursor: pointer;
    font-weight: 600;
    padding: ${({ theme }) => `${theme.spacings.xxs} 0`};
  }
`;
const SuggestionsOverviewPanel = () => {
  const { t } = useTranslation("enterprise_ai");
  const [showAll, setShowAll] = useState(false);
  const { data, isLoading } = useEventDefinitionSuggestions(showAll ? "all" : "suggested");
  if (isLoading) return null;
  if (!data || data.groups.length === 0) return null;
  return /* @__PURE__ */ React.createElement(Wrapper, { "data-testid": "suggestions-overview-panel" }, /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement("strong", null, t("suggestions.title"), data.generated_at && /* @__PURE__ */ React.createElement(React.Fragment, null, " \u2014 ", t("suggestions.last_run", { date: new Date(data.generated_at).toLocaleString() }))), /* @__PURE__ */ React.createElement(Button, { bsSize: "xsmall", onClick: () => setShowAll(!showAll) }, showAll ? t("suggestions.hide_dismissed_applied") : t("suggestions.show_dismissed_applied"))), data.summary && /* @__PURE__ */ React.createElement(Summary, { "data-testid": "suggestions-overview-summary" }, data.summary), data.groups.map((group) => /* @__PURE__ */ React.createElement(Group, { key: group.event_definition_id, open: true }, /* @__PURE__ */ React.createElement("summary", null, group.event_definition_title, " \u2014 ", t("suggestions.count", { count: group.suggestions.length })), /* @__PURE__ */ React.createElement("div", null, group.suggestions.map((s) => /* @__PURE__ */ React.createElement(SuggestionRow, { key: s.id, suggestion: s }))))));
};
export default SuggestionsOverviewPanel;
